<template>
  <div v-if="announcement.announcementTitle">
    <div class="entry-ticker-content entry-ticker-text" @mousemove="pause" @mouseleave="start">
      <a-icon style="padding-left: 16px" type="exclamation-circle" theme="filled" />
        <!-- <icon-font type="gb-icon-Warning" /> -->
      <b>【{{announcement.announcementTitle}}】</b>
      <div style="position: relative; flex: 1; overflow: hidden; min-height: 48px">
        <div class="entry-ticker-content__swiper" ref="tickerText" v-html="announcement.announcementContent.replace(/<\/?.+?\/?>/g, '')" :style="{ transform: `translate(${count * -1}px, -50%)` }">
          <!-- {{announcement.announcementContent}} -->
        </div>
      </div>
    </div>
    <div class="entry-ticker-btn">
      <a-button type="primary" @click="open">{{ $t('common_btn_renewal') }}</a-button>
    </div>
  </div>
</template>

<script>
import { getAnnouncementNotice } from '@/api/index'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      timerFlag: false,
      reqId: null,
      count: 0,
      announcement: {},
      langCodes: {
        'zh_CN': '',
        'en_US': 'En',
        'ko_KR': 'Kr'
      }
    }
  },
  methods: {
    open () {
      this.$winOpen('/#/company/serve/buy-serve?systemCode=ERP')
    },
    start () {
      const ele = this.$refs['tickerText']
      if (!ele) return
      const parent = ele.parentNode
      if (ele.offsetWidth > parent.offsetWidth) {
        this.play(ele)
      }
    },
    play (ele) {
      this.count += 2
      if (this.count > ele.offsetWidth) {
        this.count = ele.parentNode.offsetWidth * -1
      }
      this.reqId = window.requestAnimationFrame(() => {
        this.play(ele)
      })
    },
    pause () {
      window.cancelAnimationFrame(this.reqId)
    },
    stop () {
      this.count = 0
      window.cancelAnimationFrame(this.reqId)
    },
    resize () {
      this.stop()
      this.start()
    },
    infoRender (list) {
      list.shift()
      this.$destroyAll()
      if (!list?.length) return
      this.$info({
        title: list[0]['title' + this.langCodes[this.currentLang]],
        content: list[0]['msg' + this.langCodes[this.currentLang]],
        okText: this.$t('common_btn_renewal2'),
        onOk: this.open,
        onCancel: () => this.infoRender(list),
        closable: true
      })
    }
  },
  computed: {
    ...mapGetters([
      'systemCode',
      'isDemo',
      'currentLang'
    ])
  },
  watch: {
    '$root.windowMode': 'resize',
    'systemCode': {
      handler: function (systemCode) {
        if (systemCode !== 'ERP' || this.isDemo) return
        getAnnouncementNotice({ systemCode }).then(({ data }) => {
          if (Array.isArray(data) && data.length) {
            this.announcement = data[0] || {}
            setTimeout(() => {
              this.start()
            }, 2000)
          }
        })
        // queryRenewNotice({ systemCode }).then(({ data }) => {
        //   if (!Array.isArray(data)) return
        //   const sortInf = {
        //     1: 100,
        //     2: 99
        //   }
        //   const list = ['', ...(data.sort((a, b) => sortInf[b['msgType']] - sortInf[a['msgType']]))]
        //   this.infoRender(list)
        // })
      }
    }
  },
  beforeDestroy () {
    this.stop()
  }
}
</script>

<style lang="less">
.entry-ticker-bar {
  display: flex;
  background: #FEEFF0;
  border: 1px solid rgba(245, 34, 45, 0.5);
  z-index: 5;
  position: relative;
  & > div {
    height: 48px;
  }
}
.entry-ticker-text {
  white-space: nowrap;
  font-size: 14px;
  line-height: 1;
  color: #F5222D;
}
.entry-ticker-content {
  flex: 1;
  display: inline-flex;
  align-items: center;
  min-width: 0;
  min-height: 0;
  .entry-ticker-content__swiper {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
  }
}
.entry-ticker-btn {
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  box-shadow: -2px 0px 2px 0px rgba(167, 28, 37, 0.14);
  button {
    font-size: 14px;
    height: 30px;
    line-height: 28px;
  }
}
</style>
